import { useTranslation } from 'react-i18next';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { SelectOption, ToggleOption } from '@anytag/shared-types';
import { SelectorField, SingleSelectorFieldProps } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const CampaignDisplayField = (
  props: Omit<SingleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const campaignDisplayOptions: SelectOption<ToggleOption>[] = useTranslateOptions([
    { label: 'Show', value: ToggleOption.TRUE },
    { label: 'Hide', value: ToggleOption.FALSE }
  ]);

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="campaignDisplay"
      title={t('Selector.Display Campaign')}
      options={campaignDisplayOptions}
      {...props}
    />
  );
};
